const SvgLoctionSymbol = () => {
  return (
    <>
      <svg
        className="inline max-sm:hidden"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Current Location</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 5.625C8.06802 5.625 7.3125 6.38052 7.3125 7.3125C7.3125 8.24448 8.06802 9 9 9C9.93198 9 10.6875 8.24448 10.6875 7.3125C10.6875 6.38052 9.93198 5.625 9 5.625ZM6.1875 7.3125C6.1875 5.7592 7.4467 4.5 9 4.5C10.5533 4.5 11.8125 5.7592 11.8125 7.3125C11.8125 8.8658 10.5533 10.125 9 10.125C7.4467 10.125 6.1875 8.8658 6.1875 7.3125Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 2.25C7.65734 2.25 6.36967 2.78337 5.42027 3.73277C4.47087 4.68217 3.9375 5.96984 3.9375 7.3125C3.9375 9.64122 5.23791 11.7617 6.61197 13.3418C7.29212 14.124 7.97372 14.7546 8.4854 15.1896C8.68775 15.3616 8.86288 15.5024 9 15.6094C9.13711 15.5024 9.31225 15.3616 9.5146 15.1896C10.0263 14.7546 10.7079 14.124 11.388 13.3418C12.7621 11.7617 14.0625 9.64122 14.0625 7.3125C14.0625 5.96984 13.5291 4.68217 12.5797 3.73277C11.6303 2.78337 10.3427 2.25 9 2.25ZM9 16.3125C8.67743 16.7733 8.67727 16.7732 8.67709 16.7731L8.67663 16.7728L8.67531 16.7718L8.67115 16.7689L8.65685 16.7587C8.64469 16.75 8.62735 16.7376 8.60517 16.7214C8.56082 16.689 8.49708 16.6418 8.41673 16.5803C8.25608 16.4576 8.02869 16.2779 7.75679 16.0468C7.21378 15.5852 6.48913 14.915 5.76303 14.08C4.32459 12.4258 2.8125 10.0463 2.8125 7.3125C2.8125 5.67147 3.4644 4.09766 4.62478 2.93728C5.78516 1.7769 7.35897 1.125 9 1.125C10.641 1.125 12.2148 1.7769 13.3752 2.93728C14.5356 4.09766 15.1875 5.67147 15.1875 7.3125C15.1875 10.0463 13.6754 12.4258 12.237 14.08C11.5109 14.915 10.7862 15.5852 10.2432 16.0468C9.97131 16.2779 9.74392 16.4576 9.58327 16.5803C9.50292 16.6418 9.43918 16.689 9.39483 16.7214C9.37265 16.7376 9.35531 16.75 9.34315 16.7587L9.32885 16.7689L9.32469 16.7718L9.32337 16.7728L9.32291 16.7731C9.32273 16.7732 9.32257 16.7733 9 16.3125ZM9 16.3125L9.32291 16.7731C9.12923 16.9087 8.87077 16.9087 8.67709 16.7731L9 16.3125Z"
          fill="black"
        />
      </svg>
    </>
  );
};
export default SvgLoctionSymbol;
